import { PeriodicCheckOfflineService } from '~/sqlite/services/periodicCheck';

export class PeriodicCheckLocalDataSource extends PeriodicCheckOfflineService {}

export const periodicCheckLocal = new PeriodicCheckLocalDataSource();
